import { useContext } from "react";
import { AuthContext } from "../../../contexts";
import Enrollment from "./Enrollment";
import IntercityEnrollment from "./IntercityInvestments/IntercityEnrollment";

import { GROUP_NUMBER } from "../../../constants/groups";
import BOPEnrollment from "./PanhandleFirstBankBOP/BOPEnrollment";
import ProgressiveLaboratories from "./ProgressiveLabs/ProgressiveLaboratories";
import TestGroupPlan from "./TestGroup/TestGroup";

const MasterEnrollments = (): JSX.Element => {
	const { member } = useContext(AuthContext);

	// console.log("member-group-number: ", member?.group_number);

	return (
		<>
			{member?.group_number === GROUP_NUMBER.BBI_BROOKSHIRE_BROTHERS ? (
				<Enrollment />
			) : member?.group_number === GROUP_NUMBER.ICI_INTERCITY_INVESTMENTS ? (
				<IntercityEnrollment />
			) : member?.group_number === GROUP_NUMBER.BOP_PANHANDLE_FIRST_BANK ? (
				<BOPEnrollment />
			) : member?.group_number === GROUP_NUMBER.PROGRESSIVE_LABORATORIES ? (
				<ProgressiveLaboratories />
			) : member?.group_number === GROUP_NUMBER.TEST_GROUP ? (
				<TestGroupPlan />
			) : (
				<></>
			)}
		</>
	);
};

export default MasterEnrollments;
